import React from "react";

const StatViewer = ({ setShowPopup, setPopupType }) => {
  // Ensure userStats is initialized properly

  const userStatsLocal = JSON.parse(localStorage.getItem("userStats"));
  const currentDailyStreak = userStatsLocal?.currentDailyCompletionStreak || 0;
  const highestDailyStreak = userStatsLocal?.highestDailyCompletionStreak || "";
  const highStreakNotMet = currentDailyStreak < highestDailyStreak;
  const highStreakInProgress =
    currentDailyStreak > 0 && currentDailyStreak >= highestDailyStreak;

  return (
    <div
      className="DayTracker"
      style={{ position: "absolute", right: "1rem", left: "1rem" }}
    >
      <div>
        {/* stats section */}
        <div className="statViewer">
          {userStatsLocal && (
            <>
              {/* daily streak */}
              <div>{`daily streak: ${currentDailyStreak}`}</div>
              {/* highest streak conditionally shown */}
              {highStreakNotMet && (
                <div style={{ fontWeight: "normal", textTransform: "none" }}>
                  {`highest daily streak: ${highestDailyStreak}`}
                </div>
              )}
            </>
          )}
        </div>
        {/* badges section */}
        {userStatsLocal && (
          <div style={{ maxWidth: "35rem" }}>
            {/* trophy badge */}
            {highStreakInProgress && (
              <button
                className="minButtonC2A"
                onClick={() => {
                  setShowPopup(true);
                  setPopupType("statBadgeTrophy");
                }}
              >
                <span style={{ marginLeft: ".5rem" }}>🏆</span>
              </button>
            )}
            {/* fire badge */}
            {currentDailyStreak >= 7 && (
              <button
                className="minButtonC2A"
                onClick={() => {
                  setShowPopup(true);
                  setPopupType("statBadgeFire");
                }}
              >
                <span style={{ marginLeft: ".5rem" }}>🔥</span>
              </button>
            )}
            {/* dragon badge */}
            {currentDailyStreak >= 30 && (
              <button
                className="minButtonC2A"
                onClick={() => {
                  setShowPopup(true);
                  setPopupType("statBadgeDragon");
                }}
              >
                <span style={{ marginLeft: ".5rem" }}>🐉</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatViewer;
